import { podeOperarBoletos } from '@/utils/boletosCapability.mjs';
import { ref, onMounted } from 'vue';
import axios from '@/services/axios';
export function useBoletosOperacionais() {
  const habilitado = ref(false);
  onMounted(async () => {
    try {
      const { data } = await axios.get('/financeiro/cobrancas/capabilities');
      habilitado.value = podeOperarBoletos(data, () => true);
    } catch { habilitado.value = false; }
  });
  return habilitado;
}
